import { render } from "./Header.vue?vue&type=template&id=4df20421&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=4df20421&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\Normann\\Configurator Dashboard\\normann-dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df20421"]])

export default __exports__